const getDateAge = (date: Date): string => {
  if (!date) return '';

  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();

  // Convert to seconds, minutes, hours, days, months
  const diffInSeconds = Math.floor(diffInMs / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  // Calculate months (approximate)
  const dateMonth = date.getMonth();
  const dateYear = date.getFullYear();
  const nowMonth = now.getMonth();
  const nowYear = now.getFullYear();

  const diffInMonths = (nowYear - dateYear) * 12 + (nowMonth - dateMonth);

  // Return appropriate string based on time difference
  if (diffInSeconds < 60) {
    return 'now';
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${diffInMinutes === 1 ? 'minute' : 'minutes'}`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'}`;
  } else if (diffInDays < 30) {
    return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'}`;
  } else {
    return `${diffInMonths} ${diffInMonths === 1 ? 'month' : 'months'}`;
  }
};

export default getDateAge;
